import { BaseAPI } from './BaseAPI.js'
import { Extension } from '../types/index.js'

export default class ExtensionsAPI extends BaseAPI<Extension> {
  override get resource(): string {
    return '/extensions'
  }
}
